/**
 * Route for `conversion-pull-endpoint`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ConversionPullEndpointPage } from "../features/conversion-pull-endpoint/ConversionPullEndpointPage";

export const conversionPullEndpointRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/conversion-pull-endpoint",
	component: ConversionPullEndpointPage,
});

export default conversionPullEndpointRoute;
